import { createGtm } from '@gtm-support/vue-gtm';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(
    createGtm({
      id: useRuntimeConfig().public.googleAnalytics.accountId
    })
  );
});
